<template>
  <draggable
    v-if="value.length"
    :list="value"
    :sort="!readonly"
    tag="v-row"
    class="simple-gallery"
    :class="classes"
    ghost-class="simple-gallery__ghost"
    chosen-class="simple-gallery__chosen"
    v-on="$listeners"
    @input="emitter"
  >
    <v-col
      v-for="(v, index) in value"
      :key="index"
      class="simple-gallery__item d-flex child-flex"
      cols="4"
    >
      <v-img :src="v[itemSrc]" class="grey lighten-2" v-bind="$attrs">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-col>
  </draggable>
  <v-sheet v-else>{{ $t('MESSAGE.IMAGES_NOT_LOADED') }}</v-sheet>
</template>

<script>
import themeable from 'vuetify/lib/mixins/themeable';
import draggable from 'vuedraggable';

export default {
  name: 'SimpleGallery',

  components: {
    draggable
  },

  mixins: [themeable],

  inheritAttrs: false,

  props: {
    value: {
      type: Array,
      default: () => []
    },
    itemSrc: {
      type: String,
      default: 'url'
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes() {
      return {
        'simple-gallery_readonly': this.readonly,
        ...this.themeClasses
      };
    }
  },

  methods: {
    emitter() {
      this.$emit('input', this.value);
    }
  }
};
</script>
<style lang="scss">
.simple-gallery {
  &:not(&_readonly) &__item {
    cursor: grabbing;
  }

  &:not(&_readonly) &__ghost {
    box-shadow: inset 0 0 0 2px var(--v-primary-base);
  }
}
</style>
